// extracted by mini-css-extract-plugin
export default {"grid":"Delete_grid__XxoaT","cancel-btn":"Delete_cancel-btn__NGwa+","save-btn":"Delete_save-btn__wFfS+","form-submit":"Delete_form-submit__d3rPt","centered":"Delete_centered__mtgFP"};